var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{staticClass:"logo",attrs:{"src":require(("@/assets/icons/" + _vm.logo)),"alt":"marketsonics-logo"},on:{"click":function($event){return _vm.$router.push({name:'Main'})}}})])}
var staticRenderFns = []

export { render, staticRenderFns }